import React from 'react';
import { ISavedFilter } from '../../../../components/sidebar-filters/saved-filter/interface';
import { SavedFiltersList } from '../../../../components/sidebar-filters/SavedFiltersList';
import { useEnergyUsageSidebarFiltersContext } from '../context/EnergyUsageSidebarFiltersContext';

// TODO: Investigate if need to fix the height calculation to be more dynamic if needed
const HEIGHT = 'calc(100vh - 160px)'; // viewport height - page header - button bar height

interface IEnergyUsageSidebarSavedProps {
    onOpenSaveFiltersModal: (filter: ISavedFilter) => void;
}

export const EnergyUsageSidebarSaved: React.FC<IEnergyUsageSidebarSavedProps> = ({ onOpenSaveFiltersModal }) => {
    const { savedFilters, handleSavedFilterSelect, handleDeleteSavedFilter, selectedSavedFilter, appliedSavedFilter, handleApplySavedFilter } =
        useEnergyUsageSidebarFiltersContext();

    const onDeleteSavedFilter = async (filter: ISavedFilter) => {
        await handleDeleteSavedFilter(filter);

        if (selectedSavedFilter?.id === filter.id) {
            handleSavedFilterSelect(null);
        }
    };

    return (
        <div style={{ height: HEIGHT, overflowY: 'auto', padding: '8px 0' }}>
            <SavedFiltersList
                savedFilters={savedFilters}
                appliedSavedFilter={appliedSavedFilter}
                onOpenSaveFiltersModal={onOpenSaveFiltersModal}
                onDeleteSavedFilter={onDeleteSavedFilter}
                onApplySavedFilter={handleApplySavedFilter}
            />
        </div>
    );
};
